import { Col, Menu, Row } from "antd";
import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate, useOutletContext } from "react-router";
import { IAppDetails } from "../../types";

const AppSettingsRoot = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [activeTab, setActiveTab] = useState("general");
    const { appDetails } = useOutletContext<{ appDetails: IAppDetails }>();

    useEffect(() => {
        setActiveTab(location.pathname.split("/")[10] || "environment");
    }, [location.pathname]);

    return (
        <Row gutter={24}>
            <Col span={6}>
                <Menu
                    mode="inline"
                    className="ant-card-bordered"
                    selectedKeys={[activeTab]}
                    onSelect={(item) => {
                        navigate(item.key);
                        setActiveTab(item.key);
                    }}
                >
                    {/* <Menu.Item key="general">General</Menu.Item> */}
                    <Menu.Item key="environment">Environment Variables</Menu.Item>
                    {
                        appDetails.pipelineId &&
                        <Menu.Item key="git">Git</Menu.Item>
                    }
                    <Menu.Item key="scaling">Scaling</Menu.Item>
                    <Menu.Item key="domain"
                        disabled={appDetails.clusterType === "shared" || !!appDetails.associatedNamespace}
                        title={`Domain configuration is not enabled for apps deployed on a ${appDetails.clusterType === "shared" ? "shared cluster" : "cluster with access limitation"}`}
                    >
                        Domain
                    </Menu.Item>
                    {/* <Menu.Item key="deployments">Deployments</Menu.Item> */}
                    <Menu.Item key="danger-zone" danger>Danger Zone</Menu.Item>
                </Menu>
            </Col>
            <Col span={18}>
                <Outlet context={{ appDetails }} />
            </Col>
        </Row >
    );

}

export default AppSettingsRoot;